import type { FC } from 'react';
import type { RouteObject } from 'react-router';

import { lazy } from 'react';
import { Navigate } from 'react-router';
import { CONFIG } from '@src/global-config';

import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';

// ----------------------------------------------------------------------

/*const Page404 = lazy(() => import('src/pages/error/404'));*/
//const Page404 = lazy<FC>(async () =>  ({ default: import('src/pages/error/404') as FC }));

const Page404 = lazy<FC>(async () => {
  const mod = await import('src/pages/error/404');
  return { default: mod.default as FC };
});

export const routesSection = [
  { path: '/', element: <Navigate to={CONFIG.auth.redirectPath} replace /> },
  ...authRoutes,
  ...dashboardRoutes,
  { path: '*', element: <Page404 /> },
] as RouteObject[];
